module.exports = __webpack_public_path__ + "static/media/favicon.29a850dc.ico";